import { useMemo } from 'react';
import type { Middleware } from '@floating-ui/dom';
import { useTheme } from '@trinity/chat-components/components/Theme';

const DEFAULT_BASE_MODAL_Z_INDEX = 1300;
const CSS_VAR_POPPER_Z_INDEX = '--popper-z-index';

export const useZIndexMiddleware = (overrideZIndex?: number) => {
  const theme = useTheme();
  const baseModal = theme.zIndex?.baseModal ?? DEFAULT_BASE_MODAL_Z_INDEX;
  const zIndex = overrideZIndex ?? baseModal + 1;

  return useMemo(() => {
    const middleware: Middleware = {
      name: 'zIndexer',
      options: {
        zIndex,
      },
      fn: (data) => {
        data.elements.floating.style.zIndex = `var(${CSS_VAR_POPPER_Z_INDEX}, ${zIndex})`;
        return data;
      },
    };
    return middleware;
  }, [zIndex]);
};

export const useSameWidthMiddleware = (multiplier = 1) => {
  return useMemo(() => {
    const middleware: Middleware = {
      name: 'sameWidth',
      options: {
        sameWidth: true,
        multiplier,
      },
      fn: (data) => {
        const refWidth = (data.elements.reference as HTMLDivElement).offsetWidth;
        const targetWidth = Math.round(refWidth * multiplier);
        if (multiplier !== 1) {
          data.elements.floating.style.minWidth = `min(${targetWidth}px, calc(100vw - 24px))`;
          data.elements.floating.style.width = 'max-content';
          data.elements.floating.style.maxWidth = 'calc(100vw - 24px)';
        } else {
          data.elements.floating.style.width = `${refWidth}px`;
        }
        return data;
      },
    };
    return middleware;
  }, [multiplier]);
};